import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { computed, defineComponent, h, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import closeIcon from "@/assets/images/svg/close.svg";
import BookingModule from "@/store/modules/booking";
import { AccountingState, PaymentMethods, TransactionTypes } from "@/types/db/accounting";
import OffersModule from "@/store/modules/offers";
import { sumArray } from "@/utils/helpers/common";
import { BookingStatus } from "@/types/db/product-slot-state";
import { getPSSValue } from "@/utils/helpers/product-slot-state";
import { isOfferAccountingRefunded } from "@/utils/helpers/offers";
import { groupedPSS, updateEnteredAmount } from "@/utils/vue-helpers/booking";
import { ElMessageBox, ElInput } from "element-plus";
import { LogService } from "@/services/logging";
import { cloneDeep } from "lodash";
import { BookingStep } from "@/constants/booking";
import { restToPay } from "@/utils/vue-helpers/new-accountings";
export default defineComponent({
  name: "offers",
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var offers = ref([]);
    var bookingCurrency = computed(function () {
      var booking = BookingModule.selectedBooking;
      if (!booking) return "";
      var currency = booking.currency;
      return currency;
    });
    /**
     * Renders the offer element shown in the confirmation dialog
     * @param offer
     */

    function renderOfferItem(offer) {
      return h("div", {
        style: "margin-top: 16px; margin-bottom: 16px;"
      }, [// Top text
      h("div", {
        style: "margin-bottom: 22px; font-size: 16px; font-weight: bold;"
      }, t("offers.confirm-remove-msg")), // Offer block
      h("div", {
        style: "display: flex; align-items: center;"
      }, [h("div", {
        style: "flex: 1"
      }, [h("div", {
        style: "font-weight: bold; font-size: 16px;"
      }, offer.priceName), h("div", {
        style: "color: #888; font-size: 12px;"
      }, "".concat(offer.title, " ").concat(offer.discount, "%"))]), h(ElInput, {
        modelValue: offer.amount,
        style: "width: 200px; height:32px; margin-right: 10px",
        size: "default",
        placeholder: "Amount",
        disabled: true
      }, {
        prepend: function prepend() {
          return bookingCurrency.value;
        }
      })])]);
    }
    /**
     * Finds discounts and promocodes applied on a ticket that are part of offers
     * Value returned is fully based on accountings
     * e.g: Offer ("Promocode" or "Discount") 50% / CHF 6.00 -applied
     */


    function getTicketAppliedOffers(booking, pssGroup) {
      var unacceptedPSSStates = [BookingStatus.Canceled, BookingStatus.Confirmed, BookingStatus.Abandoned];

      if (pssGroup.bookingStatus && unacceptedPSSStates.includes(pssGroup.bookingStatus)) {
        // if the PSS is canceled, confirmed or abandoned, don't allow removing the offer
        return [];
      }

      var offerAccountings = booking.accountings.filter(function (acc) {
        return acc.refund !== 1 && acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT && (acc.paymentMethod === PaymentMethods.METHOD_OFFER || acc.paymentMethod === PaymentMethods.METHOD_POS_OFFER) && (acc.state === AccountingState.Completed || acc.state === AccountingState.Pending);
      });
      var offerRefundAccountings = booking.accountings.filter(function (acc) {
        return acc.refund === 1 && acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT && (acc.paymentMethod === PaymentMethods.METHOD_OFFER || acc.paymentMethod === PaymentMethods.METHOD_POS_OFFER) && acc.state === AccountingState.Completed;
      });

      if (!offerAccountings || !offerAccountings.length || !offerRefundAccountings) {
        // there are no offer accountings
        return [];
      }

      var rowPssListUuids = pssGroup.pssIds;
      var pssGroupPricesSum = pssGroup.quantity * getPSSValue(pssGroup);
      var appliedOffers = [];
      var refundAccountings = [];

      var _iterator = _createForOfIteratorHelper(offerAccountings),
          _step;

      try {
        var _loop = function _loop() {
          var acc = _step.value;
          var offerAes = acc.accountingEntriesList.filter(function (ae) {
            return rowPssListUuids.some(function (element) {
              return element === ae.productSlotStateUuid && ae.value > 0;
            });
          });
          if (!offerAes || !offerAes.length) return "continue"; // check if accounting has been refunded, in which case don't include it in the summary if the pss group is confirmed

          var refundAcc = pssGroup.bookingStatus === BookingStatus.Confirmed ? isOfferAccountingRefunded(acc, offerRefundAccountings, refundAccountings) : null;

          if (refundAcc) {
            refundAccountings.push(refundAcc.uuid);
            return "continue";
          }

          var pssGroupDiscountsSum = sumArray(offerAes.map(function (it) {
            return it.value;
          }));
          var newPriceSum = pssGroupPricesSum - pssGroupDiscountsSum;
          var offer = null;

          if (acc.promocode) {
            offer = {
              offerId: acc.accountingEntriesList[0].offerId || 0,
              title: String(acc.promocode),
              discount: ((pssGroupPricesSum - newPriceSum) / pssGroupPricesSum * 100).toFixed(0),
              amount: ((pssGroupPricesSum - newPriceSum) / 100).toFixed(2),
              priceName: pssGroup.priceName,
              priceId: pssGroup.priceId,
              pssUuids: pssGroup.pssIds,
              stillPending: acc.state === AccountingState.Pending
            };
          } else {
            var _OffersModule$offersC, _OffersModule$offersC2, _OffersModule$offersC3;

            // use the offer name or a generic "Discount Offer" if not found
            var offerName = ((_OffersModule$offersC = OffersModule.offersCommon) === null || _OffersModule$offersC === void 0 ? void 0 : (_OffersModule$offersC2 = _OffersModule$offersC.offers) === null || _OffersModule$offersC2 === void 0 ? void 0 : (_OffersModule$offersC3 = _OffersModule$offersC2.find(function (offer) {
              return offer.id === offerAes[0].offerId;
            })) === null || _OffersModule$offersC3 === void 0 ? void 0 : _OffersModule$offersC3.name) || t("label.offer-discount");
            offer = {
              offerId: acc.accountingEntriesList[0].offerId || 0,
              title: offerName,
              discount: ((pssGroupPricesSum - newPriceSum) / pssGroupPricesSum * 100).toFixed(0),
              amount: ((pssGroupPricesSum - newPriceSum) / 100).toFixed(2),
              priceName: pssGroup.priceName,
              priceId: pssGroup.priceId,
              pssUuids: pssGroup.pssIds,
              stillPending: acc.state === AccountingState.Pending
            };
          }

          appliedOffers.push(offer);
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return appliedOffers;
    }

    function confirmRemovingOffer(offer) {
      ElMessageBox.confirm(renderOfferItem(offer), {
        confirmButtonText: t("offers.yes-remove"),
        cancelButtonText: t("button.cancel"),
        title: t("offers.remove-offer"),
        confirmButtonClass: "btn-confirm-rmve-offer",
        customClass: "confirm-remove-offer"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                LogService.info("User confirmed pending offer removal", {
                  params: offer
                });
                removePendingOffer(offer);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))).catch(function () {
        LogService.info("User did not confirm offer cancellation", {
          params: offer
        });
      });
    }

    function removePendingOffer(offer) {
      // OffersModule.clearBookingOffers(booking.uuid as string);
      // BookingModule.removeOfferPromocodes(booking.uuid as string);
      var bookingCopy = cloneDeep(BookingModule.selectedBooking);
      if (!bookingCopy) return;
      var newAccountings = [];
      var linkedPSS = offer.pssUuids;

      for (var i = 0; i < bookingCopy.accountings.length; i++) {
        var accounting = bookingCopy.accountings[i];

        if (accounting.paymentMethod === PaymentMethods.METHOD_POS_OFFER && !accounting.id && accounting.state === AccountingState.Pending && accounting.accountingEntriesList.some(function (ae) {
          return ae.productSlotStateUuid && linkedPSS.includes(ae.productSlotStateUuid) && ae.value > 0 && ae.offerId === offer.offerId;
        })) {
          // if the accounting is a pending offer accounting, remove accounting entries linked to the PSS
          // if the accounting becomes empty afterwards, remove it completely.
          accounting.accountingEntriesList = accounting.accountingEntriesList.filter(function (ae) {
            return ae.productSlotStateUuid && !linkedPSS.includes(ae.productSlotStateUuid);
          });

          if (accounting.accountingEntriesList.length === 0) {
            continue;
          }
        }

        newAccountings.push(accounting);
      }

      bookingCopy.accountings = newAccountings;
      BookingModule.updateBooking(bookingCopy // update the booking with the new accountings
      ); // reload the applied offers list in the UI

      getAppliedPendingOffers(bookingCopy);
      BookingModule.setBookingStep({
        bookingUUID: BookingModule.selectedBookingUUID,
        step: BookingStep.Offers
      }); // update the rest to pay in payment step

      updateEnteredAmount(Math.abs(restToPay.value) / 100);
    }

    function getAppliedPendingOffers(booking) {
      offers.value = [];
      var groupedPssList = groupedPSS(booking.pssList);
      groupedPssList.forEach(function (pssGroup) {
        var _offers$value;

        var appliedOffers = getTicketAppliedOffers(booking, pssGroup) || [];

        (_offers$value = offers.value).push.apply(_offers$value, _toConsumableArray(appliedOffers.filter(function (offer) {
          return offer.stillPending;
        })));
      });
    }

    onMounted(function () {
      var booking = BookingModule.selectedBooking;
      if (!booking) return;
      getAppliedPendingOffers(booking);
    });
    return {
      t: t,
      offers: offers,
      confirmRemovingOffer: confirmRemovingOffer,
      closeIcon: closeIcon,
      bookingCurrency: bookingCurrency
    };
  }
});